import { createSelector, createSlice } from "@reduxjs/toolkit";

// @ts-ignore
import { ProjectType } from "../../utils/types/ProjectType.ts";

type InitialProjectState = {
  allowedRecordTypes: string[];
};

const initialState: InitialProjectState = {
  allowedRecordTypes: [],
};

export const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    setAllowedRecordTypes: (state, action) => {
      state.allowedRecordTypes = action.payload;
    },
  },
});

const getAllowedRecordTypes = (state: InitialProjectState) =>
  state.allowedRecordTypes;

export const projectTypeSelector = createSelector(
  getAllowedRecordTypes,
  (recordTypes: string[]) => {
    if (
      recordTypes.includes("SOLAR_PANEL") &&
      recordTypes.includes("SERVICE")
    ) {
      return ProjectType.FVE_SERVICE;
    }

    if (recordTypes.includes("CEMETERY")) {
      return ProjectType.CEMETERY;
    }

    if (recordTypes.includes("AREA")) {
      return ProjectType.FACILITY;
    }

    if (recordTypes.includes("PARK")) {
      return ProjectType.PARK;
    }

    if (recordTypes.includes("FAULT")) {
      return ProjectType.FVE;
    }

    return ProjectType.GENERIC;
  },
);

export const { setAllowedRecordTypes } = projectSlice.actions;

export default projectSlice.reducer;
